import { storage } from '../../utils'
import React, { Component, PropTypes } from 'react'
import { Link, browserHistory } from 'react-router'
import Dialog from '../dialog'
import { formHandler, TextInput, Button } from '../ui'

const KEYCODE_ENTER = 13

export default class SignIn extends Component {
    static displayName = 'SignIn'

    static propTypes = {
        account: PropTypes.shape({
            sign_in_errors: PropTypes.object.isRequired,
        }).isRequired,
        actions: PropTypes.shape({
            signIn: PropTypes.func.isRequired,
        }).isRequired,
        appState: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            data: {},
        }

        this.updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        if (storage.getItem('authToken')) {
            browserHistory.push('/')
        }
    }

    _onPasswordKeyPress = (e) => {
        if (e.which === KEYCODE_ENTER) {
            this.props.actions.signIn(this.state.data)
        }
    }

    signIn = () => {
        this.props.actions.signIn(this.state.data)
    }

    render() {
        const errors = this.props.account.sign_in_errors

        const header = (
            <div className="logo">
                <img alt="" src="/img/hayden-logo.png" width="200" />
            </div>
        )

        const subFooter = (
            <div className="text-center">
                <p>Don't have an account? <Link to="/sign-up">Sign up</Link></p>
                <p><Link to="/forgot-password">Forgot your password?</Link></p>
            </div>
        )

        let non_field_errors = null

        if (errors.non_field_errors) {
            non_field_errors = errors.non_field_errors.map(
                (error, index) => <span key={ index }>{ error }<br /></span>
            )

            non_field_errors = (
                <div className="alert alert--error">
                    { non_field_errors }
                </div>
            )
        }

        return (
            <Dialog allowClose={ false } background={ false } header={ header } size="small" subFooter={ subFooter }>
                <h4 className="align-center">Welcome back</h4>
                { non_field_errors }
                <TextInput
                    error={ errors.email }
                    name="email"
                    placeholder="Email"
                    type="email"
                    updateValue={ this.updateValue }
                    value={ this.state.data.email }
                />
                <TextInput
                    error={ errors.password }
                    name="password"
                    onKeyPress= { this._onPasswordKeyPress }
                    placeholder="Enter your password"
                    type="password"
                    updateValue={ this.updateValue }
                    value={ this.state.data.password }
                />
                <Button
                    fullWidth
                    loading={ this.props.appState.loading }
                    onClick={ this.signIn }
                    status="primary"
                >
                    Login
                </Button>
            </Dialog>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/account/sign_in.js